import React from "react";

export default function Footer() {
  return (
    <footer>
      This project was coded by{" "}
      <a href="https://github.com/Ndambaza" target="_blank" rel="noreferrer">
        Natalie Dambaza
      </a>
      , is open-sourced on{" "}
      <a
        href="https://github.com/Ndambaza/weather-app-react"
        target="_blank"
        rel="noreferrer"
      >
        Github
      </a>
      and website hosted on{" "}
      <a
        href="https://sunny-entremet-a7f605.netlify.app/"
        target="_blank"
        rel="noreferrer"
      >
        Netlify
      </a>
    </footer>
  );
}
